import React from "react";
export const renderIf = (condition, component) => condition ? component : React.createElement(React.Fragment, null);
//# sourceMappingURL=renderIf.js.map